module.exports = __webpack_public_path__ + "img/img16.dc3b7735.png";